import { render, staticRenderFns } from "./newStuff.vue?vue&type=template&id=3e4635d1&"
import script from "./newStuff.vue?vue&type=script&lang=js&"
export * from "./newStuff.vue?vue&type=script&lang=js&"
import style0 from "./newStuff.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports